import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { ensureExists } from '~/utils'

import { type BrandAccount } from './useBrandAccountQuery'
import { useBrandAccountQueryKey } from './useBrandAccountQueryKey'

export const useBrandAccountQueryBrandAccount = () => {
  const { t } = useTranslation()
  const queryKey = useBrandAccountQueryKey()
  const { data } = useQuery<BrandAccount>({ enabled: false, queryKey })

  return ensureExists(data, t('assertion_failed'))
}
